var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEatingHabits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "EatingHabits",
    "data-name": "EatingHabits",
    xmlns: "http://www.w3.org/2000/svg",
    width: 109,
    height: 112,
    viewBox: "0 0 109 112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(-0.135 0.024)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Icon.BG",
    cx: 54.5,
    cy: 56,
    rx: 54.5,
    ry: 56,
    transform: "translate(0.135 -0.024)",
    fill: "#f2f6df"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_14771",
    "data-name": "Path 14771",
    d: "M542.917,437.371c-10.742,0-19.448,7.885-19.448,17.613s8.706,17.613,19.448,17.613,19.446-7.886,19.446-17.613-8.707-17.613-19.446-17.613",
    transform: "translate(-494.388 -412.517)",
    fill: "#abca47"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14772",
    "data-name": "Path 14772",
    d: "M542.958,435.7c-11.667,0-21.159,8.669-21.159,19.325s9.492,19.325,21.159,19.325,21.159-8.668,21.159-19.325S554.626,435.7,542.958,435.7m0,35.225c-9.779,0-17.735-7.133-17.735-15.9s7.956-15.9,17.735-15.9,17.735,7.133,17.735,15.9-7.956,15.9-17.735,15.9",
    transform: "translate(-494.43 -412.56)",
    fill: "#ce9327"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14773",
    "data-name": "Path 14773",
    d: "M542.515,443.737A11.089,11.089,0,1,0,553.6,454.826a11.089,11.089,0,0,0-11.089-11.089",
    transform: "translate(-494.192 -412.36)",
    fill: "#87b44e"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14774",
    "data-name": "Path 14774",
    d: "M542.557,442.066a12.8,12.8,0,1,0,12.8,12.8,12.816,12.816,0,0,0-12.8-12.8m0,22.179a9.377,9.377,0,1,1,9.378-9.377,9.388,9.388,0,0,1-9.378,9.377",
    transform: "translate(-494.233 -412.401)",
    fill: "#87b44e"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14775",
    "data-name": "Path 14775",
    d: "M558.49,457.118,527.24,450.7a.49.49,0,1,0-.2.959l31.251,6.421a.465.465,0,0,0,.1.01.49.49,0,0,0,.1-.969",
    transform: "translate(-494.309 -412.188)",
    fill: "#bbd36c"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14776",
    "data-name": "Path 14776",
    d: "M555.3,446.115l-25.563,17a.489.489,0,1,0,.542.815l25.564-17a.49.49,0,0,0-.543-.815",
    transform: "translate(-494.238 -412.304)",
    fill: "#bbd36c"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14778",
    "data-name": "Path 14778",
    d: "M535.488,442.375a.489.489,0,0,0-.818.535l15.656,23.912a.489.489,0,0,0,.818-.535Z",
    transform: "translate(-494.114 -412.398)",
    fill: "#bbd36c"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14779",
    "data-name": "Path 14779",
    d: "M532.547,447.25a.49.49,0,0,0-.546.813l20.181,13.576a.49.49,0,1,0,.546-.813Z",
    transform: "translate(-494.183 -412.275)",
    fill: "#bbd36c"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14780",
    "data-name": "Path 14780",
    d: "M557.578,451.174l-28.5,5.382a.489.489,0,0,0,.09.969.455.455,0,0,0,.091-.008l28.5-5.382a.489.489,0,1,0-.181-.961",
    transform: "translate(-494.26 -412.176)",
    fill: "#bbd36c"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14781",
    "data-name": "Path 14781",
    d: "M551.09,442.473a.487.487,0,0,0-.677.138L536.1,464.26a.489.489,0,0,0,.816.539l14.31-21.649a.488.488,0,0,0-.138-.677",
    transform: "translate(-494.078 -412.394)",
    fill: "#bbd36c"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14783",
    "data-name": "Path 14783",
    d: "M541.572,452.582c-2.222,1.146-3.589,2.912-3.057,3.945s2.44,2.6,4.986-.2c1.683-1.849,3.591-2.912,3.058-3.945s-2.766-.942-4.987.2",
    transform: "translate(-494.019 -412.164)",
    fill: "#fffffd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14789",
    "data-name": "Path 14789",
    d: "M545.374,447.946a.755.755,0,1,0,1.068-.037.755.755,0,0,0-1.068.037",
    transform: "translate(-493.852 -412.263)",
    fill: "#7d6c4f"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14790",
    "data-name": "Path 14790",
    d: "M546.91,449.3a.755.755,0,1,0,1.068-.037.756.756,0,0,0-1.068.037",
    transform: "translate(-493.814 -412.229)",
    fill: "#7d6c4f"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14791",
    "data-name": "Path 14791",
    d: "M548.417,451.293a.755.755,0,1,0,.792.716.757.757,0,0,0-.792-.716",
    transform: "translate(-493.789 -412.173)",
    fill: "#7d6c4f"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14792",
    "data-name": "Path 14792",
    d: "M549.6,453.254a.755.755,0,1,0,.792.716.756.756,0,0,0-.792-.716",
    transform: "translate(-493.76 -412.125)",
    fill: "#7d6c4f"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14793",
    "data-name": "Path 14793",
    d: "M547.637,454.434a.755.755,0,1,0,.792.716.755.755,0,0,0-.792-.716",
    transform: "translate(-493.809 -412.096)",
    fill: "#7d6c4f"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14794",
    "data-name": "Path 14794",
    d: "M547.8,456.475a.755.755,0,1,0,.792.716.756.756,0,0,0-.792-.716",
    transform: "translate(-493.805 -412.045)",
    fill: "#7d6c4f"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14795",
    "data-name": "Path 14795",
    d: "M545.757,456.635a.755.755,0,1,0,.792.716.756.756,0,0,0-.792-.716",
    transform: "translate(-493.856 -412.042)",
    fill: "#7d6c4f"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14805",
    "data-name": "Path 14805",
    d: "M568.341,470.027a16.358,16.358,0,0,0-10.808-4.056c-3.433,0-11.151,4.771-12.4,7.087s-4.019,6.517-4.019,9.334a15.8,15.8,0,0,0,2.189,8.195c4.387,7.277,9.657,8.227,12.7,8.227,2.925,0,8.736-.764,11.114-2.1,2.5-1.408,7.682-5.5,6.842-14.319-.466-4.908-2.173-9.355-5.614-12.365",
    transform: "translate(-493.952 -411.811)",
    fill: "#e5ea92"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14806",
    "data-name": "Path 14806",
    d: "M569.388,468.908a17.94,17.94,0,0,0-11.817-4.435c-4.006,0-12.211,5.034-13.752,7.893-.222.412-.494.884-.789,1.4-1.441,2.51-3.413,5.949-3.413,8.662a17.346,17.346,0,0,0,2.408,8.986c3.537,5.87,8.383,8.971,14.012,8.971,2.628,0,9.015-.7,11.868-2.3,2.6-1.467,8.553-5.942,7.616-15.8-.544-5.717-2.665-10.341-6.133-13.375m-2.99,26.5c-2.035,1.147-7.585,1.906-10.361,1.906-4.559,0-8.388-2.519-11.385-7.484a14.308,14.308,0,0,1-1.967-7.4c0-1.9,1.81-5.048,3.006-7.136.311-.54.6-1.037.829-1.469.957-1.774,8.088-6.28,11.05-6.28a14.869,14.869,0,0,1,9.8,3.676c2.867,2.508,4.63,6.434,5.1,11.356.767,8.069-3.988,11.664-6.068,12.836",
    transform: "translate(-493.989 -411.847)",
    fill: "#377225"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14807",
    "data-name": "Path 14807",
    d: "M552.369,475.26a4.566,4.566,0,0,0,2.546,6.687,4.567,4.567,0,0,0-2.546-6.687",
    transform: "translate(-493.688 -411.581)",
    fill: "#e5ea92"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14808",
    "data-name": "Path 14808",
    d: "M552.675,474.566a.768.768,0,0,0-.975.371,5.328,5.328,0,0,0,2.946,7.739.75.75,0,0,0,.287.057.77.77,0,0,0,.688-.427,5.329,5.329,0,0,0-2.946-7.74m1.846,6.316a3.524,3.524,0,0,1-1.721-4.521,3.523,3.523,0,0,1,1.721,4.521",
    transform: "translate(-493.707 -411.6)",
    fill: "#9fad6a"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14809",
    "data-name": "Path 14809",
    d: "M557.754,481.581a5.624,5.624,0,0,0-1.138,3.806,4.565,4.565,0,0,0,4.829-5.279,5.641,5.641,0,0,0-3.691,1.474",
    transform: "translate(-493.569 -411.463)",
    fill: "#e5ea92"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14810",
    "data-name": "Path 14810",
    d: "M561.458,479.357a5.328,5.328,0,0,0-5.588,6.11.764.764,0,0,0,.763.7h.005a5.328,5.328,0,0,0,5.589-6.11.764.764,0,0,0-.769-.7m-1.7,4.058a1.4,1.4,0,1,1,.921-2.436,4.2,4.2,0,0,1-.921,2.436",
    transform: "translate(-493.588 -411.48)",
    fill: "#9fad6a"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14811",
    "data-name": "Path 14811",
    d: "M561.52,484.265a5.631,5.631,0,0,0-1.945,3.466,4.567,4.567,0,0,0,5.868-4.1,5.632,5.632,0,0,0-3.923.631",
    transform: "translate(-493.496 -411.377)",
    fill: "#e5ea92"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14812",
    "data-name": "Path 14812",
    d: "M565.623,482.9a7.232,7.232,0,0,0-1.377-.127,5.548,5.548,0,0,0-3.147.879,6.374,6.374,0,0,0-2.266,3.989.765.765,0,0,0,.6.855,7.167,7.167,0,0,0,1.376.128,5.558,5.558,0,0,0,3.15-.879,6.373,6.373,0,0,0,2.265-3.989.769.769,0,0,0-.6-.856m-2.546,3.588a4.2,4.2,0,0,1-2.532.6,3.521,3.521,0,0,1,3.967-2.769,4.211,4.211,0,0,1-1.435,2.173",
    transform: "translate(-493.515 -411.396)",
    fill: "#9fad6a"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14813",
    "data-name": "Path 14813",
    d: "M556.542,476.58a5.637,5.637,0,0,0,.289,3.964,4.567,4.567,0,0,0,2.637-6.652,5.622,5.622,0,0,0-2.926,2.689",
    transform: "translate(-493.578 -411.615)",
    fill: "#e5ea92"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14814",
    "data-name": "Path 14814",
    d: "M559.21,473.191a5.331,5.331,0,0,0-3.052,7.7.77.77,0,0,0,.692.437.757.757,0,0,0,.278-.052,5.331,5.331,0,0,0,3.052-7.7.77.77,0,0,0-.969-.385m-.149,4.4a4.2,4.2,0,0,1-1.785,1.9,3.523,3.523,0,0,1,1.784-4.5,4.2,4.2,0,0,1,0,2.6",
    transform: "translate(-493.596 -411.633)",
    fill: "#9fad6a"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14815",
    "data-name": "Path 14815",
    d: "M561.35,475.524a4.567,4.567,0,0,0,3.66,6.148,4.565,4.565,0,0,0-3.66-6.148",
    transform: "translate(-493.458 -411.573)",
    fill: "#e5ea92"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14816",
    "data-name": "Path 14816",
    d: "M561.528,474.791a.767.767,0,0,0-.9.533,5.327,5.327,0,0,0,4.236,7.115.727.727,0,0,0,.16.017.768.768,0,0,0,.737-.55,5.329,5.329,0,0,0-4.237-7.115m2.909,5.9a3.523,3.523,0,1,1-.412-2.569,4.227,4.227,0,0,1,.412,2.569",
    transform: "translate(-493.476 -411.594)",
    fill: "#9fad6a"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14817",
    "data-name": "Path 14817",
    d: "M553.039,482.386a5.632,5.632,0,0,0-3.974,0,4.568,4.568,0,0,0,6.446,3.108,5.637,5.637,0,0,0-2.473-3.111",
    transform: "translate(-493.756 -411.415)",
    fill: "#e5ea92"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14818",
    "data-name": "Path 14818",
    d: "M553.391,481.714a4.895,4.895,0,0,0-2.15-.459,7.331,7.331,0,0,0-2.438.438.769.769,0,0,0-.454.941,6.388,6.388,0,0,0,2.873,3.577,4.943,4.943,0,0,0,2.151.456,7.3,7.3,0,0,0,2.437-.438.765.765,0,0,0,.453-.938,6.378,6.378,0,0,0-2.872-3.577m-.017,3.418a3.4,3.4,0,0,1-1.484-.3,4.2,4.2,0,0,1-1.763-1.918,5.6,5.6,0,0,1,1.114-.12,3.377,3.377,0,0,1,1.483.306,4.205,4.205,0,0,1,1.763,1.917,5.612,5.612,0,0,1-1.113.119",
    transform: "translate(-493.774 -411.433)",
    fill: "#9fad6a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEatingHabits);
export default __webpack_public_path__ + "static/media/EatingHabits.9196730e4028ad171b0a6de053473018.svg";
export { ForwardRef as ReactComponent };